import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { logoutUser, getUserProfile } from 'Actions/account_action'
import { getRentedVideos, getRentedPlaylists } from 'Actions/vod_action'
import AccountResponsiveShell from './AccountResponsiveShell'
import { getAccountNavItems, resolveActiveNavId } from './accountNavItems'
import { cn } from '../../lib/utils'

/**
 * Wraps a legacy (non-migrated) account page in AccountResponsiveShell
 * so the dweb sidebar stays available.
 */
export const withAccountShell = (WrappedComponent, options = {}) => {
  const AccountShellWrapped = props => {
    const {
      contact,
      customerProfile,
      logoutUser: onLogout,
      regions,
      rentedVideos,
      rentedPlaylists,
      getUserProfile: fetchProfile,
      getRentedVideos: fetchVideos,
      getRentedPlaylists: fetchPlaylists,
      location
    } = props

    const [referralActive, setReferralActive] = useState(false)

    useEffect(() => {
      fetchProfile?.()
      fetchVideos?.()
      fetchPlaylists?.()
    }, [])

    useEffect(() => {
      if (regions?.regions?.length > 0) {
        setReferralActive(
          Boolean(regions.regions[0].centers[0].referral_program?.status)
        )
      }
    }, [regions])

    const profile =
      customerProfile?.data ||
      contact ||
      JSON.parse(localStorage.getItem('contact') || 'null')

    const hasVod = Boolean(
      rentedVideos?.data?.videos?.length > 0 ||
        rentedPlaylists?.data?.playlists?.length > 0
    )

    const activeNavId = resolveActiveNavId(location?.pathname)
    const title = useMemo(() => {
      if (options.title) return options.title
      const items = getAccountNavItems({ referralActive, hasVod })
      return items.find(item => item.id === activeNavId)?.label || 'My account'
    }, [referralActive, hasVod, activeNavId])

    return (
      <AccountResponsiveShell
        title={title}
        profile={profile}
        referralActive={referralActive}
        hasVod={hasVod}
        onLogout={onLogout}
        activeNavId={activeNavId}
        backPath={options.backPath}
        showMobileHeader={options.showMobileHeader ?? false}
        contentClassName={cn(
          'account-shell-legacy-content',
          options.contentClassName
        )}
      >
        <WrappedComponent {...props} />
      </AccountResponsiveShell>
    )
  }

  const Connected = connect(
    state => ({
      contact: state.accountreducer.loginDetails?.data?.contact ?? null,
      customerProfile: state.accountreducer.customerProfile,
      regions: state.centerreducer.regionsDetails,
      rentedVideos: state.vodReducer.rentedVideos,
      rentedPlaylists: state.vodReducer.rentedPlaylists
    }),
    {
      logoutUser,
      getUserProfile,
      getRentedVideos,
      getRentedPlaylists
    }
  )(AccountShellWrapped)

  const wrappedName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  Connected.displayName = `withAccountShell(${wrappedName})`
  return Connected
}

export default withAccountShell
